import React from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import CardStyles from '../../styles/cards'

const ClaimLineMessage = (props) => {
  const { classes = {} } = props

  return (
    <Card className={ classnames(classes.SummayCard, classes.baseCard, classes.MessageBox) }>
      <Row>
        <Col lg={12}>
          <p>{props.msg}</p>
        </Col>
      </Row>
    </Card>
  )
}

const styles = {
  ...CardStyles,
  MessageBox: {
    margin: '10px 0',
    padding: '0 20px'
  }
}

export default withStyles(styles)(ClaimLineMessage)



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimLineMessage.js